module.exports = __webpack_public_path__ + "static/media/YM57_4.0d480b3d.jpg";